import AdminTable from '../Components/AdminTable';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { Modal, TextField, Button, Select, MenuItem, InputLabel, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'
import { Paper, TableBody, makeStyles, TableCell, TableRow, IconButton } from '@material-ui/core';
import React, { useState, useEffect, forwardRef } from 'react';
import axios from 'axios';
import { Edit, Cancel } from '@mui/icons-material';
import Cookies from 'universal-cookie';
import { useHistory } from 'react-router';
import './UserAdmin.css'
const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function UserAdmin() {
    const history = useHistory();
    const [records, setRecords] = useState([])
    const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
    const [removeUserID, setRemoveUserID] = useState(0);
    const [changeTable, setChangeTable] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [error, setErrorMessage] = useState('');
    const [success, setSuccessMessage] = useState('');
    const cookies = new Cookies();
    const userToken = cookies.get('tokenCTF');
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenError(false);
        setOpenSuccess(false);
    };
    const useStyles = makeStyles(theme => ({
        pageContentUser: {
            marginTop: '15vh',
            marginLeft: '30vw',
            marginBottom: '2vh',
            width: '60%',
            padding: theme.spacing(3),
            overflowX: 'auto',
            overflowY: 'hidden',
        },
        modalAdUser: {
            position: 'absolute',
            width: 400,
            backgroundColor: 'white',
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            //padding: '16px 32px 24px',
            padding: theme.spacing(2, 4, 3, 4),
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
        textfieldAdUser: {
            width: '100%'
        },
        buttonModified: {
            margin: theme.spacing(1),
        }

    }))
    const classes = useStyles();


    const headCells = [
        { id: 'id', label: 'ID' },
        { id: 'name', label: 'Nombres' },
        { id: 'user', label: 'Usuario' },
        { id: 'email', label: 'Correo' },
        { id: 'type', label: 'Tipo', disableSorting: true },
        { id: 'actions', label: 'Acciones', disableSorting: true },

    ]
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = AdminTable(records, headCells);

    //REMOVE USER
    function handleOpenRemoveDialog(id) {
        setOpenRemoveDialog(true);
        setRemoveUserID(id);

    };

    const handleCloseRemoveDialog = () => {
        setOpenRemoveDialog(false);
        setRemoveUserID(0);
    };


    //TABLE


    useEffect(() => {
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/usersAdmin/getUsers`, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else if (response.data.noAdmin) {
                history.push('/user');
            }
            else {
                setRecords(response.data)
                setChangeTable(false)
            }
        }).catch((error) => {
            setErrorMessage('Error al cargar los usuarios');
            setOpenError(true);
        });
    }, [changeTable])

    function deleteUser(id) {
        axios.delete(`https://${process.env.REACT_APP_BASE_URL}/api/usersAdmin/deleteUser/${id}`, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                setChangeTable(true);
                handleCloseRemoveDialog();
                setSuccessMessage(response.data.messageSuccess);
                setOpenSuccess(true);
            }
        }).catch((error) => {
            setErrorMessage("Error al eliminar usuario");
            setOpenError(true);
        })
    }
    //FORM
    function UserForm() {

        //ALERT
        const [openSuccess, setOpenSuccess] = useState(false);
        const [openError, setOpenError] = useState(false);
        const [error, setErrorMessage] = useState('');
        const [success, setSuccessMessage] = useState('');
        const handleClose = (event, reason) => {
            if (reason === 'clickaway') {
                return;
            }

            setOpenError(false);
            setOpenSuccess(false);
        };
        //Styles - MODAL FORM

        const [modalAd, setModalAd] = useState(false);
        const openCloseModal = () => {
            setModalAd(!modalAd);
        }

        //FORM-formikAd
        const formikAd = useFormik({
            initialValues: {
                NamesAd: '',
                UserAd: '',
                TypeAd: 'user',
                EmailAd: '',
                PasswordAd: '',
                VerifyPasswordAd: ''

            },
            validationSchema: yup.object({
                NamesAd: yup.string()
                    .required('Campo requerido *'),
                UserAd: yup.string()
                    .min(3, 'Usuario muy corto')
                    .max(15, 'Usuario demasiado largo')
                    .required('Campo requerido *'),
                EmailAd: yup.string()
                    .email('Correo invalido')
                    .required('Campo requerido *'),
                PasswordAd: yup.string()
                    .matches(
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
                        "Debe tener mínimo 8 carácteres, una mayúscula, una minúscula, un número y un carácter especial"
                    ).required('Campo requerido *'),
                VerifyPasswordAd: yup.string()
                    .required('Campo requerido *')
                    .oneOf([yup.ref('PasswordAd'), null], 'Contraseñas no coinciden'),
            }),
            onSubmit: values => {
                axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/usersAdmin/insertUsers`, {
                    name: values.NamesAd,
                    username: values.UserAd,
                    type: values.TypeAd,
                    email: values.EmailAd,
                    password: values.PasswordAd,
                }, {
                    headers: { 'Authorization': userToken }
                }).then((response) => {
                    if (response.data.noAuth) {
                        cookies.remove('tokenCTF', { path: '/' });
                        history.push('/login');
                    }
                    else {
                        if (response.data.messageError) {
                            setErrorMessage(response.data.messageError);
                            setOpenError(true);
                        }
                        else if (response.data.messageSuccess) {
                            setChangeTable(true);
                            handleCloseRemoveDialog();
                            setSuccessMessage(response.data.messageSuccess);
                            setOpenSuccess(true);
                            setModalAd(!modalAd);
                            formikAd.handleReset();
                        }
                        else {
                            setErrorMessage('');
                            setSuccessMessage('');
                            setOpenError(false);
                            setOpenSuccess(false);
                        }
                    }
                }).catch((error) => {
                    setErrorMessage('Error al insertar usuario');
                    setOpenError(true);
                });
            }
        });
        const body = (
            <div className="modalAdUser">
                <div align="center">
                    <h2>Registro de Usuario</h2>
                </div>
                <form
                    onSubmit={formikAd.handleSubmit}
                    autoComplete="off"
                >

                    <TextField
                        label="Nombres" className="textfieldAdUser"
                        name='NamesAd'
                        {...formikAd.getFieldProps("NamesAd")}
                    />
                    {formikAd.touched.NamesAd && formikAd.errors.NamesAd ? <span className="spanRedFontsize">{formikAd.errors.NamesAd}</span> : null}

                    <br />
                    <TextField
                        label="Usuario" className="textfieldAdUser"
                        name='UserAd'
                        {...formikAd.getFieldProps("UserAd")}
                    />
                    {formikAd.touched.UserAd && formikAd.errors.UserAd ? <span className="spanRedFontsize">{formikAd.errors.UserAd}</span> : null}

                    <br />
                    <TextField

                        label="Correo"
                        className="textfieldAdUser"
                        name='EmailAd'
                        {...formikAd.getFieldProps("EmailAd")}

                    />

                    {formikAd.touched.EmailAd && formikAd.errors.EmailAd ? <span className="spanRedFontsize">{formikAd.errors.EmailAd}</span> : null}
                    <InputLabel id="userType" className="labelMarginTop">Tipo</InputLabel>
                    <RadioGroup row
                        aria-label="userType"
                        defaultValue="user"
                        name="radio-buttons-group"
                        className="radioMarginPadding"
                        {...formikAd.getFieldProps("TypeAd")}

                    >
                        <FormControlLabel value="user" control={<Radio size="small" />} label="Usuario" />
                        <FormControlLabel value="adminCTF21_UDLA!*" control={<Radio size="small" />} label="Administrador" />

                    </RadioGroup>

                    {formikAd.touched.TypeAd && formikAd.errors.TypeAd ? <span className="spanRedFontsize">{formikAd.errors.TypeAd}</span> : null}


                    <TextField label="Contraseña" name='PasswordAd'
                        className="textfieldMargin" variant="standard"
                        {...formikAd.getFieldProps("PasswordAd")}
                        type="password" />
                    {formikAd.touched.PasswordAd && formikAd.errors.PasswordAd ? <span className="spanRedFontsize">{formikAd.errors.PasswordAd}</span> : null}

                    <TextField label="Confirmar Contraseña"
                        name='VerifyPasswordAd'
                        className="textfieldAdUser"
                        {...formikAd.getFieldProps("VerifyPasswordAd")}
                        type="password" />
                    {formikAd.touched.VerifyPasswordAd && formikAd.errors.VerifyPasswordAd ? <span className="spanRedFontsize">{formikAd.errors.VerifyPasswordAd}</span> : null}

                    <br />
                    <div align="right">
                        <Button variant='outlined' color="primary" className="buttonModified" type="submit" >Registrar </Button>
                        <Button variant='outlined' color="secondary" className="buttonModified" onClick={() => openCloseModal()}>Cancelar</Button>
                    </div>
                </form>


            </div>
        )
        return (
            <div align="right">
                <Button color='primary' variant='outlined' className="button" onClick={() => openCloseModal()} >Nuevo Usuario</Button>
                <Modal open={modalAd} onClose={openCloseModal}>
                    {body}
                </Modal>
                <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%', top: '0' }}>
                        {error}
                    </Alert>
                </Snackbar>
                <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%', top: '0' }}>
                        {success}
                    </Alert>
                </Snackbar>
            </div>

        )
    }
    //USER MODIFY
    function UserEdit(ide) {
        //ALERT

        const [openSuccess, setOpenSuccess] = useState(false);
        const [openError, setOpenError] = useState(false);
        const [error, setErrorMessage] = useState('');
        const [success, setSuccessMessage] = useState('');
        const [modal, setModal] = useState(false);
        const [name, setName] = useState('');
        const [username, setUsername] = useState('');
        const [email, setEmail] = useState('');
        const [type, setType] = useState('');
        const [password, setPassword] = useState('');
        const openCloseModal = () => {
            setModal(!modal);
        }
        const handleClose = (event, reason) => {
            if (reason === 'clickaway') {
                return;
            }
        };
        const updateUser = () => {
            axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/usersAdmin/updateUser`, {
                id: ide,
                name: name,
                username: username,
                email: email,
                type: type,
                password: password

            }, {
                headers: { 'Authorization': userToken }
            }).then((response) => {
                if (response.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else {
                    if (response.data.messageError) {
                        setErrorMessage(response.data.messageError);
                        setOpenError(true);
                    }
                    else if (response.data.messageSuccess) {
                        setSuccessMessage(response.data.messageSuccess);
                        setOpenSuccess(true);
                        setName('');
                        setUsername('');
                        setEmail('');
                        setType('');
                        setPassword('');
                        setChangeTable(true);
                    }
                    else {
                        setErrorMessage('');
                        setSuccessMessage('');
                        setOpenError(false);
                        setOpenSuccess(false);
                    }
                }
            }).catch((error) => {
                setErrorMessage('Error al actualizar usuario');
                setOpenError(true);
            });
        };
        const body = (
            <div className="modalAdUser">
                <div align="center">
                    <h2>Modificar usuario</h2>
                </div>
                <TextField label="Nombres" className="textfieldAdUser" onChange={(e) => { setName(e.target.value) }} />
                <br />
                <TextField label="Usuario" className="textfieldAdUser" onChange={(e) => { setUsername(e.target.value) }} />
                <br />
                <TextField label="Correo" className="textfieldAdUser" onChange={(e) => { setEmail(e.target.value) }} />
                <br />
                <br />
                <InputLabel id="userType">Tipo</InputLabel>
                <Select labelId="userType" name="Tipo" value={type} onChange={(e) => { setType(e.target.value) }} >
                    <MenuItem value="">
                        <em>Ninguno</em>
                    </MenuItem>
                    <MenuItem value={"user"}>Usuario</MenuItem>
                    <MenuItem value={"adminCTF21_UDLA!*"}>Administrador</MenuItem>
                </Select>

                <br />
                <TextField label="Contraseña" className="textfieldAdUser" onChange={(e) => { setPassword(e.target.value) }} />
                <br />
                <div align="right">
                    <Button variant='outlined' color="primary" className="buttonModified" onClick={() => updateUser()}>Actualizar</Button>
                    <Button variant='outlined' color="secondary" className="buttonModified" onClick={() => openCloseModal()}>Cancelar</Button>
                </div>
            </div>
        )
        return (
            <div className="containerUser" align="left">
                <Button className="button" onClick={() => openCloseModal()} ><Edit color="primary" fontSize="small" /></Button>
                <Modal open={modal} onClose={openCloseModal}>
                    {body}
                </Modal>
                <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%', top: '0' }}>
                        {error}
                    </Alert>
                </Snackbar>
                <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%', top: '0' }}>
                        {success}
                    </Alert>
                </Snackbar>
            </div>
        )
    }


    return (
        <div className="userAdmin">



            <Paper className="pageContentUser">
                <div>{UserForm()}</div>
                <TblContainer>
                    <TblHead />

                    <TableBody>

                        {
                            recordsAfterPagingAndSorting().map(item => (
                                <TableRow key={item.user_id} onMouseEnter={(e) => { }}>
                                    <TableCell>{item.user_id}</TableCell>
                                    <TableCell>{item.name}</TableCell>
                                    <TableCell>{item.username}</TableCell>
                                    <TableCell>{item.email}</TableCell>
                                    <TableCell>{item.type}</TableCell>
                                    <TableCell>
                                        <div className="actions-admin">
                                            <UserEdit ide={item.user_id} />
                                            <IconButton onClick={(e) => { handleOpenRemoveDialog(item.user_id) }}>
                                                <Cancel fontSize="small" color="error" />
                                            </IconButton>
                                        </div>
                                    </TableCell>

                                </TableRow>
                            ))}

                    </TableBody>
                </TblContainer>
                <TblPagination />
            </Paper>
            <Dialog
                open={openRemoveDialog}
                onClose={handleCloseRemoveDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Eliminar Usuario"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        ¿Está seguro que desea eliminar el usuario?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(e) => { deleteUser(removeUserID) }}>Sí</Button>
                    <Button onClick={handleCloseRemoveDialog} autoFocus>
                        No
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error" sx={{ width: '100%', top: '0' }}>
                    {error}
                </Alert>
            </Snackbar>
            <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success" sx={{ width: '100%', top: '0' }}>
                    {success}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default UserAdmin;